import serverCall from "../../serverCall";

const createSubscription = async (body) => {
    try {
        const response = await serverCall.post(`subscription/org/create-subscription`, body);
        console.log("🚀  createSubscription  response:1", response);
        return response;
    } catch (error) {
        throw error;
    }
}

const getSubscription = async () => {
    try {
        const response = await serverCall.get(`subscription/org/active-subscriptions`);
        console.log("🚀  getSubscription  response:1", response);
        return response;
    } catch (error) {
        throw error;
    }
}

const cancelSubscription = async () => {
    try {
        const response = await serverCall.post(`subscription/org/cancel-subscription`);
        console.log("🚀  cancelSubscription  response:1", response);
        return response;
    } catch (error) {
        throw error;
    }
}

const sendInquiry = async (body) => {
    try {
        const response = await serverCall.post(`subscription/contact-sales`, body);
        return response;
    } catch (error) {
        throw error;
    }
}

const SubscriptionService = {
    createSubscription,
    getSubscription,
    cancelSubscription,
    sendInquiry,
}

export default SubscriptionService